import './App.css';
import { BrowserRouter, Routes, Route, Navigate, useHistory } from 'react-router-dom';
import Landing from './Landing/Landing';


function App() {



  return (
    <BrowserRouter>


          <div>
            <Routes>
              <Route path='/' element={<Landing />} />
            </Routes>
          </div>


    </BrowserRouter>
  );
}

export default App;
